<template>
  <admin-modal v-show="show" class="long" :title="title" @cancel="closeModal">
    <!-- edit fields -->
    <template v-slot:body>
      <el-checkbox-group v-model="checkList" class="checkboxWrapper">
        <el-checkbox class="checkbox" label="warn">Warn</el-checkbox>
        <el-checkbox class="checkbox" label="info">Info</el-checkbox>
      </el-checkbox-group>
      <div class="modal__row">
        <!-- URL edting field -->
        <div
          v-if="filterRecorderList.length > 0"
          class="modal__field long-field"
        >
          <div
            v-for="(data, index) in filterRecorderList"
            :key="index"
            class="modal__item"
          >
            <h3>
              {{ new Date(Number(data.eventTime)).toUTCString() }}
            </h3>
            <p>Level: {{ data.level }}</p>
            <p>Massage: {{ data.message }}</p>
          </div>
        </div>
        <div v-else class="defoultSource">No recorder</div>
      </div>
    </template>

    <!-- footer -->
    <template v-slot:footer>
      <!-- Cancel button -->
      <div class="modal-btn cancel-btn" @click="closeModal">
        Cancel
      </div>
    </template>
  </admin-modal>
</template>

<script>
import AdminModal from "@/components/admin/modals/AdminModal.vue";
import { getAPI, token } from "@/api/params.js";

export default {
  name: "RecorderInfoModal",
  components: { AdminModal },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Recorder status"
    },
    streamName: {
      type: String
    },
    flagServer: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      recorderInfo: [],
      checkList: ["warn", "info"]
    };
  },
  computed: {
    filterRecorderList() {
      return this.recorderInfo.filter(
        e => e.stream === this.streamName && this.checkList.includes(e.level)
      );
    }
  },
  watch: {
    flagServer() {
      fetch(`${getAPI()}/streamer_notify/list?token=${token}&category=recorder`)
        .then(response => response.json())
        .then(commits => {
          commits.map(e => {
            Number(e.eventTime);
          });
          this.recorderInfo = commits;
        });
    }
  },

  created() {
    fetch(`${getAPI()}/streamer_notify/list?token=${token}&category=recorder`)
      .then(response => response.json())
      .then(commits => {
        commits.map(e => {
          Number(e.eventTime);
        });
        this.recorderInfo = commits;
      });
  },
  methods: {
    closeModal() {
      // User try to close modal
      this.$emit("shangeFlagUpdateServer");
      this.$emit("close");
      /** clear errors after closing so it not will appear for new stream */
    }
  }
};
</script>
<style>
.checkboxWrapper .el-checkbox__input.is-checked + .el-checkbox__label {
  color: black;
}
.checkboxWrapper .el-checkbox__inner {
  background-color: #ddd;
  border: none;
}
</style>
<style scoped>
.modal__item {
  background-color: #c4c4c4;
  margin: 3px 0px;
  border-radius: 10px;
  padding: 4px;
}

.defoultSource {
  margin-top: 10px;
}

.checkbox {
  color: Black !important;
}
.checkboxWrapper {
  color: red;
}
.el-checkbox-button .checkbox {
  color: red;
}
.el-checkbox-button.is-checked .el-checkbox-button__inner {
  background-color: red;
  color: black;
}
.checkbox .is-checked {
  color: rgb(42, 53, 112) !important;
}
</style>
